import React, { useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import DashboardTotalsWidget from './Sections/DashboardTotalsWidget';
import WaterRightsByEstablishmentChart from './Sections/WaterRightsByEstablishmentChart';
import ReportabilityByCompanyChart from './Sections/ReportabilityByCompanyChart';
import WorkStatusByCompanyChart from './Sections/WorkStatusByCompanyChart';
import WaterRightsExerciseChart from './Sections/WaterRightsExerciseChart';
import WaterRightsTypeChart from './Sections/WaterRightsTypeChart';
import DashboardMap from './Sections/DashboardMap';
import WaterRightsDashboardGrid from './Sections/WaterRightsDashboardGrid';
import ActivitiesDashboardGrid from './Sections/ActivitiesDashboardGrid';
import {Icons} from '../../../utils/Icons';

const WaterRightsDashboard = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: Icons.house },
		{ to: '#', label: 'Medio Ambiente', icon: Icons.environment },
		{ to: '/water-rights/list', label: 'Derechos de Agua', icon: Icons.water },
	];

	useEffect(() => {
		// TODO: Fetch dashboard data
	}, []);

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Panel'
						links={breadcrumbLinks}
						icon={Icons.dashboard}
					/>

					{/* Filas 1-6: Gráficos (izquierda md=9) + Mapa (derecha md=3) */}
					<Row className='mb-3' style={{ minHeight: '600px' }}>

						{/* Columna izquierda: 3 filas de gráficos */}
						<Col md={9} className='d-flex flex-column gap-3'>

							{/* Fila 1: Totales + Gráfico por Establecimiento + Gráfico Incidencias */}
							<Row className='flex-grow-1'>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Totales</h5>
										</CardHeader>
										<CardBody>
											<DashboardTotalsWidget />
										</CardBody>
									</Card>
								</Col>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Derechos de Agua por tipo de Establecimiento</h5>
										</CardHeader>
										<CardBody>
											<WaterRightsByEstablishmentChart />
										</CardBody>
									</Card>
								</Col>
							</Row>

							{/* Fila 2: Reportabilidad por Empresas + Estados de Obra por Empresas */}
							<Row className='flex-grow-1'>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Reportabilidad de Obra por Empresas</h5>
										</CardHeader>
										<CardBody>
											<ReportabilityByCompanyChart />
										</CardBody>
									</Card>
								</Col>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Estados de Obra por Empresas</h5>
										</CardHeader>
										<CardBody>
											<WorkStatusByCompanyChart />
										</CardBody>
									</Card>
								</Col>
							</Row>

							{/* Fila 3: Ejercicio de Derechos + Tipo de Derechos */}
							<Row className='flex-grow-1'>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Ejercicio de Derechos de Agua</h5>
										</CardHeader>
										<CardBody>
											<WaterRightsExerciseChart />
										</CardBody>
									</Card>
								</Col>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Tipo de Derechos de Agua</h5>
										</CardHeader>
										<CardBody>
											<WaterRightsTypeChart />
										</CardBody>
									</Card>
								</Col>
							</Row>

						</Col>

						{/* Columna derecha: Mapa (span 6 filas) */}
						<Col md={3}>
							<Card className='h-100'>
								<CardBody className='p-0'>
									<DashboardMap />
								</CardBody>
							</Card>
						</Col>

					</Row>

					{/* Fila 7-8: Grilla Derechos de Agua + Grilla Actividades */}
					<Row className='mb-3'>
						<Col md={6}>
							<Card className='h-100'>
								<CardHeader>
									<h5 className='card-title mb-0'>Lista de Derechos de Agua</h5>
								</CardHeader>
								<CardBody>
									<WaterRightsDashboardGrid />
								</CardBody>
							</Card>
						</Col>
						<Col md={6}>
							<Card className='h-100'>
								<CardHeader>
									<h5 className='card-title mb-0'>Lista de Actividades</h5>
								</CardHeader>
								<CardBody>
									<ActivitiesDashboardGrid />
								</CardBody>
							</Card>
						</Col>
					</Row>

				</Container>
			</div>
		</React.Fragment>
	);
};

export default WaterRightsDashboard;
